import { useTranslation } from "react-i18next";

import { ConfigProvider, Tabs } from "antd";

import { useSelector } from "react-redux";
function EmployeeMenuProfile({ selectedMenu = "", onSelectMenu = () => { }, menuList = [] }) {
  const { t } = useTranslation();
  const { roles } = useSelector((state) => state.company);
  function getItem(rules, label, key) {
    let list = [...roles];
    if (!list.includes(rules)) return null;
    return { label, key };
  }

  const EMPLOYEE_MENU_LIST = [
    getItem("ACCESS_PROFILE|EMPLOYEE_INFO", t('employee.employee_info.header'), 'employee_info'),
    getItem("ACCESS_PROFILE|EMPLOYMENT_INFO", t('employee.employment.header'), 'employment'),
    getItem("ACCESS_PROFILE|SALARY_INFO", t('employee.salary.header'), 'salary'),
  ]?.filter(Boolean);

  return (
    <ConfigProvider
      theme={{
        components: {
          Tabs: {
            itemHoverColor: "var(--tab-color)",
            itemActiveColor: "var(--tab-color)"
          },
        },
      }}
    >
      <Tabs items={menuList} onChange={onSelectMenu} />
    </ConfigProvider>
  );
}

export default EmployeeMenuProfile;
